// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/sass/fonts.scss
// module id = b3PD
// module chunks = 0